<script setup lang="ts">
const colorMode = useColorMode();
const color = computed(() => (colorMode.value === 'dark' ? '#1a1a2e' : '#ffffff'));

useHead({
    htmlAttrs: { lang: 'en' },
    meta: [{ key: 'theme-color', name: 'theme-color', content: color }]
});

useSeoMeta({
    viewport: 'width=device-width, initial-scale=1, maximum-scale=1',
    title: 'Dependable Dispatch Service',
    description: 'Mobile medical service dispatch management system'
});
</script>

<template>
    <UApp>
        <NuxtLoadingIndicator color="#0d9488" />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>
